import React, { useCallback, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import Icon from "../atoms/icon";
import classNames from "classnames";
import { eventInternalLinkClick } from "../../utility/data-layer";
import HTMLReactParser, { domToReact } from "html-react-parser";
import CircleArrowDown from "../../icons/circle-arrow-down.svg";
import ScrollLink from "../../utility/scroll-link";
import anchorify from "../../utility/anchorify";

const KeyMessages = ({ data, position, pagePath }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen((value) => !value), []);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        discoverMore
        checkDimensions
        technicalSpecifications
      }
    }
  `);
  const onClickFeaturePdp = useCallback(() => {
    eventInternalLinkClick({
      click_element: "pdp_rassurance",
      position: `pdp_${position}`,
      link_text: data?.linkText ? `pdp_${data?.linkText}` : null,
      action: !open ? "pdp_open" : "pdp_close",
      slug: pagePath,
    });
  }, [open, position, pagePath, data?.linkText]);

  return (
    <div
      className={classNames(
        `box-accordion${open ? " open" : ""} box-accordion--pdp box-accordion--pdp-${position}`,
        data?.customName && `box-accordion--pdp-${data.customName}`
      )}
    >
      <button
        className="box-accordion__title"
        onClick={() => {
          toggleOpen();
          onClickFeaturePdp();
        }}
        disabled={!data.abstract}
      >
        <span className="box-accordion__title-icon">
          {(data.hooverStIcons.alternativeIcon || !!data.hooverStIcons.icon?.length) && (
            <Icon
              className={`icon-${data.hooverStIcons.icon}`}
              name={data.hooverStIcons.alternativeIcon ? "custom" : data.hooverStIcons.icon}
              url={
                data.hooverStIcons.width || data.hooverStIcons.height
                  ? data.hooverStIcons.alternativeIcon?.node?.publicURL
                  : data.hooverStIcons.alternativeIcon?.node?.resize?.src ||
                    data.hooverStIcons.alternativeIcon?.node?.publicURL
              }
              width={data.hooverStIcons.width}
              height={data.hooverStIcons.height}
              alt={
                data.hooverStIcons.alternativeIcon
                  ? data.hooverStIcons.alternativeIcon.value?.description
                  : ""
              }
            />
          )}
          {data.title}
        </span>
        <span className="box-accordion__price">
          <div className="box-accordion__button">
            <CircleArrowDown className="circle-arrow-down" />
          </div>
        </span>
      </button>
      {data?.abstract && (
        <div className="box-accordion__content">
          <div className="box-accordion__content-inner">
            {HTMLReactParser(data.abstract, {
              replace: (node) => {
                if (node.name === "p" && !node.next) {
                  return (
                    <p>
                      {domToReact(node.children, {})}
                      {data?.link ? (
                        <>
                          <span> </span>
                          {data.link === "dimensions" ? (
                            <ScrollLink
                              href={`#${anchorify(labelManagerLabels.technicalSpecifications)}`}
                              className="product-detail__view-st"
                              onClick={() => {
                                const event = new CustomEvent("open-dimensions");
                                document.dispatchEvent(event);
                              }}
                            >
                              <span>{labelManagerLabels.checkDimensions}</span>
                            </ScrollLink>
                          ) : (
                            <Link className="product-detail__view-st" to={data.link}>
                              {labelManagerLabels.discoverMore}
                            </Link>
                          )}
                        </>
                      ) : null}
                    </p>
                  );
                }
              },
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default KeyMessages;
export const fragment = graphql`
  fragment KeyMessagesPdpFragment on LiferayKeyMessagesPdp {
    title
    abstract
    hooverStPosition {
      position
    }
    hooverStMultipleLines {
      multipleLines
    }
    hooverStTarget {
      target
    }
    hooverStIcons {
      alternativeIcon {
        node {
          publicURL
          resize {
            src
          }
        }
        value {
          description
        }
      }
      icon
      width
      height
    }
    link
    skus
    linkText
    customName
  }
`;
